export const clientErrorsFields = {
  firstname: 'Prénom',
  lastname: 'Nom de famille',
  prenom: 'Prénom',
  nom: 'Nom de famille',
  email: 'Email',
  mail: 'Email',
  tel: 'Téléphone',
  mobilelivraison: 'Numéro de téléphone de livraison',
  password: 'Mot de passe',
  policy: 'Conditions générales',
  civilite: 'Civilité',
  methodepaiement: 'Méthode de paiement',
  adressefacturation: 'Adresse de facturation',
  address: 'Adresse de facturation',
  cpfacturation: 'Code postal',
  villefacturation: 'Ville',
  city: 'Ville',
  civilitelivraison: 'Civilité destinataire',
  adresselivraison: 'Adresse destinataire',
  cplivraison: 'Code postal destinataire',
  zipCode: 'Code postal',
  villelivraison: 'Ville destinataire',
  prenomlivraison: 'Prénom destinataire',
  nomlivraison: 'Nom destinataire',
  nomsociete: 'Nom de la société'
};
